import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import FastClick from 'fastclick'
FastClick.attach(document.body);
import VueBlu from "vue-blu";
Vue.use(VueBlu);


new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
